import React from 'react';
import MobileDashboardDrawingLotto90 from "./MobileDashboardDrawingLotto90";
import {useLotto90} from "../../../store/lotto90/Lotto90Context";
import TabView from "../../lotto/TabView";
import ResultHistoryMobile from "./ResultHistoryMobile";
import RecentTicketMobile from "./RecentTicketMobile";
import LottoBettingBoardMobile from "../../betting/mobile/LottoBettingBoardMobile";

const Sale = () => {

    const {t} = useLotto90()

    const tabs = [
        t("labels:drawing.betting"),
        t("labels:drawing.result")
    ];
    const children = [
        <RecentTicketMobile/>,
        <ResultHistoryMobile/>
    ]

    return (
        <div id="lotto90-mobile">
            <div className="betting-board lotto90">
                <div className="m-0">
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <MobileDashboardDrawingLotto90/>
                            <LottoBettingBoardMobile
                                useHook={useLotto90}
                                priceKey="lotto90PackagePrices"
                                wrapperClass="lotto90-mobile-board"
                            />
                            <div className="tab-view border-all mt-2 num-pad-btn">
                                <TabView children={children} tabs={tabs}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Sale;